// extracted by mini-css-extract-plugin
export default {"SpinnerContainer":"Spinner_SpinnerContainer__aa9ZZ","loaderSpinner":"Spinner_loaderSpinner__SkjpC","SpinnerText":"Spinner_SpinnerText__Fe7If"};